import { render, staticRenderFns } from "./Select2Search.vue?vue&type=template&id=1cfddc4c&scoped=true"
import script from "./Select2Search.vue?vue&type=script&lang=js"
export * from "./Select2Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfddc4c",
  null
  
)

export default component.exports